import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class AddHeaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = localStorage.getItem('token') ? localStorage.getItem('token') : localStorage.getItem('temporaltoken');

    // Verificar si la solicitud contiene un FormData
    const isFormData = req.body instanceof FormData;

    let jsonReque: HttpRequest<any>;
    if (token) {
      // Si es FormData, no añadir el Content-Type manualmente
      if (isFormData) {
        jsonReque = req.clone({
          setHeaders: {
            Authorization: `bearer ${token}`
          }
        });
      } else {
        jsonReque = req.clone({
          setHeaders: {
            Authorization: `bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
      }
    } else {
      if (isFormData) {
        jsonReque = req.clone(); // No añadir Content-Type en FormData
      } else {
        jsonReque = req.clone({
          setHeaders: {
            'Content-Type': 'application/json'
          }
        });
      }
    }

    return next.handle(jsonReque);
  }
}
